import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../../../common/hooks/useTimeZone'
import { Element } from '../../../../common/html/element'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { selectScore } from '../../store/slice'

export const LastUpdate = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const data = useSelector(selectScore((data) => data?.publicDateId))

  return (
    <Element className="fstItalic mlAuto">
      <Translate value="companySummary.score.LAST_UPDATED_DATE" />
      {formatDateTime(data, FORMAT.DATE, locale, timezone)}
    </Element>
  )
}
